module.exports = __webpack_public_path__ + "img/cooperation02.61a90df5.png";